import { wymhFeatures } from "@/mocks/wymh-content";

const WYMH_ACCENT_STYLES: Record<string, string> = {
  primary: "bg-primary-50 border-primary-100 text-primary-600",
  accent: "bg-accent-50 border-accent-100 text-accent-600",
  secondary: "bg-secondary-50 border-secondary-100 text-secondary-600",
};

export default function WymhReading() {
  return (
    <section id="wymh-reading" className="wymh-anchor w-full bg-background-50 pt-20 md:pt-24 pb-16 md:pb-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div className="lg:sticky lg:top-24">
            <div className="relative w-full max-w-[380px] mx-auto">
              <div className="absolute top-6 left-0 w-full h-full rounded-[32px] bg-primary-200/50 rotate-3"></div>
              <div className="relative w-full h-[620px] rounded-[32px] border-4 border-foreground-900 overflow-hidden bg-foreground-950">
                <img
                  src="/images/wymh-reading-phone.png"
                  alt="五一漫画启动界面"
                  title="五一漫画海量漫画精彩不断"
                  className="w-full h-full object-top"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50 border border-background-200 shadow-none">
                <i className="ri-live-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span className="text-foreground-800 text-sm font-medium">实时追更中</span>
              </div>
            </div>
          </div>

          <div>
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-label font-bold tracking-widest mb-4">
              <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
              阅读体验
            </span>
            <h2 className="wymh-heading text-foreground-950 text-4xl md:text-5xl leading-tight mb-4">
              把追更这件事做到顺手
            </h2>
            <p className="text-foreground-600 text-base leading-8 mb-10">
              五一漫画把阅读器当成核心来做：干净、流畅、省流量，还能把你看到哪一页默默记住。下面这四件事，是我们花最多时间打磨的地方。
            </p>

            <div className="flex flex-col gap-4">
              {wymhFeatures.map((feature, index) => (
                <div
                  key={feature.title}
                  className="flex gap-4 md:gap-5 p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200"
                >
                  <span
                    className={`shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-xl border flex items-center justify-center ${
                      WYMH_ACCENT_STYLES[feature.accent] || WYMH_ACCENT_STYLES.primary
                    }`}
                  >
                    <i className={`${feature.icon} text-2xl`}></i>
                  </span>
                  <div>
                    <div className="flex items-center gap-3 mb-2">
                      <h3 className="text-foreground-950 font-bold text-lg">{feature.title}</h3>
                      <span className="wymh-heading text-foreground-200 text-xl leading-none">
                        0{index + 1}
                      </span>
                    </div>
                    <p className="text-foreground-600 text-sm leading-7">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}